angular.module('core').directive('trPageTitle', trPageTitle);

/* @ngInject */
function trPageTitle($rootScope, $interpolate, $state, $window) {
  const directive = {
    restrict: 'A',
    link,
  };

  return directive;

  function link(scope, element) {
    $rootScope.$on('$stateChangeSuccess', listener);

    function listener(event, toState) {
      if (toState.data && toState.data.pageTitle) {
        const stateTitle = $interpolate(toState.data.pageTitle)(
          $state.$current.locals.globals,
        );
        // `$window.title` is the server-rendered site name, which the CMS
        // settings feed. Previously hardcoded, so changing the site name in
        // the admin left every state-titled page still saying "HostFolk".
        const siteName = $window.title || 'HostFolk';
        element.html(stateTitle + ' - ' + siteName);
      } else {
        element.html($window.title);
      }
    }
  }
}
